<template>
  <main class="content">
    <h4>Stock Status Grade</h4>
    <div class="search-bar">
      <div class="label-wrapper">
          <label>Search</label>
        </div>
        <select v-model="selectedGrowerCode" id="grower-code">
          <option disabled value="">Select Grower Code</option>
          <option v-for="code in growerCodes" :key="code" :value="code">{{ code }}</option>
        </select>
        <input type="text" v-model="selectedGrowerCode" class="grower-code-select">
        <select v-model="selectedSeason" id="season" >
          <option disabled value="">Select Season</option>
          <option v-for="sn in seasons" :key="sn" :value="sn">{{ sn }}</option>
        </select>
        <input type="text" v-model="selectedSeason" class="grower-code-select">
      <button>Search</button>
  </div>
    
    <table class="stock-table">
      <thead>
        <tr>
          <th>Parchment Total</th>
          <th>Clean Coffee Total</th>
          <th>Clean Coffee Warehoused Total</th>
          <th>Catalogued Coffee Total</th>
          <th>Sold Coffee Total</th>
          <th>Unsold Coffee Total</th>
          <th>Percentage</th>
          <th>Total Clean Coffee</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in stockData" :key="index">
          <td>{{ row.parchmentTotal }}</td>
          <td>{{ row.cleanCoffeeTotal }}</td>
          <td>{{ row.cleanCoffeeWarehousedTotal }}</td>
          <td>{{ row.cataloguedCoffeeTotal }}</td>
          <td>{{ row.soldCoffeeTotal }}</td>
          <td>{{ row.unsoldCoffeeTotal }}</td>
          <td>{{ row.percentage }}</td>
          <td>{{ row.totalCleanCoffee }}</td>
        </tr>
      </tbody>
    </table>
    <v-card-actions>
      <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
      <v-spacer></v-spacer>
      <v-pagination
        v-model="page"
        :length="numberOfLinks"
        :total-visible="7"
        color="secondary"
                class="accent--text logoutbtn"
      ></v-pagination>
    </v-card-actions>
  </main>
  </template>
  
  <script>
  export default {
    name: 'StockStatusSummery',
    data() {
    return {
      userName: "Florence Kaweria",
      selectedGrowerCode: "",
      selectedSeason: "",
      // growerCodes: ["XBE32FO1", "ABC123", "XYZ789"],
      // seasons:["2023/2024", "2095/2096", "2024/2025"],
      growerCodes: [],
			seasons: [],
      stockData: [
        {
          parchmentTotal: '1,000 KG',
          cleanCoffeeTotal: '1,000 KG',
          cleanCoffeeWarehousedTotal: '1,000 KG',
          cataloguedCoffeeTotal: '1,000 KG',
          soldCoffeeTotal: '640 KG',
          unsoldCoffeeTotal: '360 KG',
          percentage: '36%',
          totalCleanCoffee: '1,000 KG',
        },
      ],
      paginatedItems: [],
      permissions: [],
      numberOfLinks: 0,
      numberOfItemsPerPage: 7,
      currentPage: 0,
      page: 1
    };
  },
  computed: {
    totalPrice() {
      return this.grades.reduce((sum, grade) => sum + grade.totalPrice, 0);
    }
  },
  mounted () {
		this.getGrowerCodes()
		this.getSeasons()
	},
  methods: {
    search() {
      // Implement search functionality
    },
    getSeasons () {
			this.seasons.push('2023/2024')
      this.seasons.push('2024/2025')
			const month = this.currentYear.getMonth()
			const year = this.currentYear.getFullYear()
			if (month < 10) {
				this.seasons.push(year + '/' + (year + 1))
				this.seasons.push(year + 1 + '/' + (year + 2))
			} else {
				this.seasons.push(year + 1 + '/' + (year + 2))
				this.seasons.push(year + 3 + '/' + (year + 4))
			}
		},
    getGrowerCodes () {
			const url = config.serverURI + '/organization/get-marketers'
			axios.get(url)
				.then(response => {
					console.log('FCS - ', response.data)
					//this.growerCodes = response.data
          response.data.forEach(x => {
            console.log('->> ', x['organisationCode']);
            this.growerCodes.push(x['organisationCode'])
          })
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.growerCodes
		},
    getOrg() {
			const url = config.serverURI + '/growerstatus/org'
			axios.get(url, {})
				.then(response => {
					this.code = response.data.code
          this.name = response.data.name
          console.log('Organisation Code===>'+ this.code +' Name==> '+this.name)
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.grower
		},
  }
  };
  </script>
  
  <style scoped>
  .search-section {
    margin: 20px 0;
    padding: 10px;
  }
  
  .search-bar {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .search-bar input {
    padding: 5px;
  }
  .table_area_box_empty {
    position: relative;
    background: #fff;
    overflow-x: auto;
    /* //border: 1px solid #707070; */
  }
  
  .table_area_box {
    position: relative;
    background: #fff;
    overflow-x: auto;
  /* //border: 1px solid #707070; */
    
  }
  
  .thead {
    background-color: #00513B !important;
    color: white;
    font-size: 12px;
  }
  
  .table tbody tr > td.actions {
    font-size: 20px !important;
    color: #733D29 !important;
    padding-top: 0px;
  }
  
  .pagination {
    background-color: red;
  }
  
  .paginationtext {
    color: #733D29;
  }
  
  .pagination > li > a,
  .pagination > li > span {
    border: 1px solid #F2D0A7;
    color: #733D29;
  }
  
  .pagination > li.active > .page-link {
    background: #00513B;
    color: #fff;
  }
  
  .table {
    overflow-x: auto;
  }
  
  td {
    max-width: 200px; /* Set a maximum width for cells */
    overflow: hidden;
    text-overflow: ellipsis; /* Show ellipsis (...) for text overflow */
    white-space: nowrap; /* Prevent text from wrapping */
  
  }

  /*
  search
  */
  .stock-status-grade {
    display: flex;
    height: 100vh;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #004d25;
    color: #fff;
  }
  
  .logo img {
    height: 40px;
  }
  
  .title {
    font-size: 24px;
    font-weight: bold;
  }
  
  .user-profile {
    display: flex;
    align-items: center;
  }
  
  .user-profile img {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
  
  .sidebar {
    width: 200px;
    background-color: #e9f5f1;
    padding: 20px;
  }
  
  .sidebar ul {
    list-style: none;
    padding: 0;
  }
  
  .sidebar li {
    padding: 10px 0;
    font-weight: bold;
  }
  
  .sidebar .active {
    color:#004d25;
  }
  
  .content {
    flex: 1;
    padding: 20px;
  }
  
  .search-bar {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
  
  .search-bar label {
    margin-right: 10px;
  }
  
  .search-bar select {
    padding: 5px;
    margin-right: 10px;
  }
  
  .search-bar button {
    background-color:#004d25;
    color: white;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
  }
  
  .stock-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .stock-table th, .stock-table td {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: left;
  }
  
  .stock-table th {
    background-color: #00513B !important;
    color: white;
    font-size: 12px;
  }
  
  .stock-table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .stock-table tr:last-child td {
    font-weight: bold;
    color: rgb(13, 12, 12);
    font-size: 12px;
  }
  .search-bar {
    display: flex;
    justify-content: space-between;  
    gap: 20px;
}

.label-wrapper {
    display: flex;
    align-items: center;
  }
  
  .label-wrapper {
    margin-right: -1px; /* Adjust to ensure no gap between label and input */
  }
  
  .custom-label {
    background-color: #f0f0f0; /* Greyish background color */
    color: #333; /* Text color */
    padding: 10px 15px; /* Padding inside the label */
    border-radius: 15px 15px 15px 15px; /* Slightly curved on the left side */
    font-size: 16px; /* Font size */
    font-weight: bold; /* Optional: makes the text bold */
    display: inline-block; /* Allows the label to fit its content */
    white-space: nowrap; /* Prevents label from wrapping to the next line */
  }
  input[type="text"] {
    padding: 10px 15px; /* Padding inside the input */
    border: 1px solid #ccc; /* Border color */
    border-radius: 15px 15px 15px 15px; /* Slightly curved on the right side */
    font-size: 16px; /* Font size */
    box-sizing: border-box; /* Ensures padding and border are included in width calculation */
    outline: none; /* Removes the default focus outline */
  }
  .grower-code-select {
    background-color: #dde7e4 !important;
    width: 200px; /* Adjust width as needed */
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
  }
  </style>
  